"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemberAvatarURL = exports.getContactAvatarURL = exports.getConfigData = exports.setRestConfig = exports.setAccessToken = exports.clientServiceApi = exports.customApi = exports.serviceApi = exports.baseApi = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("./config");
Object.defineProperty(exports, "getConfigData", { enumerable: true, get: function () { return config_1.getConfigData; } });
Object.defineProperty(exports, "setAccessToken", { enumerable: true, get: function () { return config_1.setAccessToken; } });
Object.defineProperty(exports, "setRestConfig", { enumerable: true, get: function () { return config_1.setRestConfig; } });
const getConfigHeaders = () => (0, config_1.getConfigData)().headers;
const getBaseURL = (suffix) => (`${(0, config_1.getConfigData)().GATEWAY_API_URL}${suffix || ''}`);
const getServicesURL = () => (`${(0, config_1.getConfigData)().GATEWAY_API_URL}${(0, config_1.getConfigData)().SERVICES_URL_SUFFIX}`);
const getClientServicesURL = () => (`${(0, config_1.getConfigData)().GATEWAY_API_URL}${(0, config_1.getConfigData)().CLIENT_SERVICE_URL_SUFFIX}`);
const getCustomURL = () => (`${(0, config_1.getConfigData)().GATEWAY_API_URL}${(0, config_1.getConfigData)().CUSTOM_URL_SUFFIX}`);
const getMemberAvatarURL = (contactId) => (`${getCustomURL()}/v1.0/members/${contactId}/profilepicture?secure=true`);
exports.getMemberAvatarURL = getMemberAvatarURL;
const getContactAvatarURL = (contactId) => (`${getCustomURL()}/v1.0/contacts/${contactId}/profilepicture?secure=true`);
exports.getContactAvatarURL = getContactAvatarURL;
const clientRequest = (restConfig) => {
    const restRequest = (method, url, data = {}, headers = {}) => (axios_1.default.request(Object.assign(Object.assign({ method,
        url, headers: Object.assign(Object.assign({}, getConfigHeaders()), headers) }, restConfig), data)));
    const get = (url, params, headers = {}) => restRequest('get', url, params, headers);
    const post = (url, data, headers = {}) => restRequest('post', url, { data }, headers);
    const put = (url, data, headers = {}) => restRequest('put', url, { data }, headers);
    const remove = (url, data, headers = {}) => restRequest('delete', url, { data }, headers);
    return {
        get,
        post,
        put,
        remove,
    };
};
const baseApi = (serviceSuffix) => (clientRequest({ baseURL: getBaseURL(serviceSuffix) }));
exports.baseApi = baseApi;
const serviceApi = () => (clientRequest({ baseURL: getServicesURL() }));
exports.serviceApi = serviceApi;
const customApi = () => (clientRequest({ baseURL: getCustomURL() }));
exports.customApi = customApi;
const clientServiceApi = () => (clientRequest({ baseURL: getClientServicesURL() }));
exports.clientServiceApi = clientServiceApi;
//# sourceMappingURL=transport.js.map